function pad(value, length = 2) {
  return String(Math.floor(value)).padStart(length, '0');
}

export function formatTimestamp(seconds, separator = '.') {
  const milliseconds = Math.round((seconds % 1) * 1000);
  return `${pad(seconds / 3600)}:${pad((seconds % 3600) / 60)}:${pad(seconds % 60)}${separator}${pad(milliseconds, 3)}`;
}

export function chunksToText(chunks, includeTimestamps = true) {
  return chunks.map((chunk) => (
    includeTimestamps
      ? `[${formatTimestamp(chunk.timestamp[0])} --> ${formatTimestamp(chunk.timestamp[1])}] ${chunk.text}`
      : chunk.text
  )).join('\n');
}

export function chunksToSrt(chunks) {
  return chunks.map((chunk, index) => [
    index + 1,
    `${formatTimestamp(chunk.timestamp[0], ',')} --> ${formatTimestamp(chunk.timestamp[1], ',')}`,
    chunk.text,
    '',
  ].join('\n')).join('\n');
}
